import React, { useEffect } from "react";
import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { LoadingSpinner } from "components/graphql-views";
import Viewer from "components/viewer/context";
import { UserRole } from "types/gql-types";

const EmailVerified: React.FC = () => {
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const username = params.get("u");
  const viewer = React.useContext(Viewer);

  useEffect(() => {
    if (viewer && viewer.logins?.length) {
      const { logins: [{ roles }] } = viewer;
      if (roles) {
        if (roles.includes(UserRole.CLIENT)) {
          navigate("/properties");
        } else if (roles.includes(UserRole.PROPERTY_MANAGER) ||
        roles.includes(UserRole.SUPERVISOR)) {
          navigate("/dash/manager/lists");
        } else if (roles.includes(UserRole.ADMIN)) {
          navigate("/dash/admin");
        }
      } else {
        navigate(`/login?u=${encodeURIComponent(username ?? "")}`);
      }
    } else {
      navigate(`/login?u=${encodeURIComponent(username ?? "")}`);
    }
  }, []);
  return (
    <Grid container justifyContent="center" spacing={2} direction="row">
      <LoadingSpinner />
    </Grid>
  );
};

export default EmailVerified;
